import {GameStepsExecutionResultEnum} from "../game-runner/interfaces/game-step/game-run-step.interface";

import {IGamblingSessionAnalytics} from "./gambling-session-analytics.interface";
import {TimeSpan} from "@sparkware/app-utils";
import {GameInfo} from "../games/game-info";
import {
    GamblingSessionStatus,
    GamblingSessionUpdateData
} from "../firebase/topics/gambling-session/gambling-session-topic.model.interface";


export enum GamblingSessionManagerErrorCodes {
    OK = 0,
    GeneralError = 1,
    GamblingSessionAlreadyExist = 71,
    UserInRestrictionPeriod = 72,
    TryAgain = 74,
    ContactSupport = 75
}

export class GamblingSessionData {
    constructor(private readonly data: GamblingSessionUpdateData) {
    }

    get gamblingSessionId(): string {
        return this.data.gamblingSessionId;
    }
    get sessionStatus(): GamblingSessionStatus {
        return this.data.sessionStatus;
    }

    get sessionActivationTime(): Date | null {
        const sessionActivationTime = this.data.sessionActivationTime ?? 0;
        if(sessionActivationTime > 0) {
            return new Date(sessionActivationTime * 1000); // sessionActivationTime comes in epoch time
        }

        return null;
    }
    get sessionDuration(): TimeSpan | null {
        const startDate = this.sessionActivationTime;
        if(startDate) {
            return TimeSpan.fromMilliseconds(Date.now() - startDate.getTime());
        }

        return null;
    }
    get sessionTotalBets(): number {
        return this.data.sessionTotalBets;
    }
    get sessionTotalWins(): number {
        return this.data.sessionTotalWins;
    }

    get restrictionExpirationDate(): Date | null {
        if(this.data.restrictionExpirationDate) {
            return new Date(this.data.restrictionExpirationDate * 1000); // restrictionExpirationDate comes in epoch time
        }

        return null;
    }

    //readonly updateCounter?: number;
}

export interface IGamblingSessionService {
    readonly isEnabled: boolean;
    readonly isInitialized: boolean;
    getGamblingSessionState(): Promise<GamblingSessionData>;
    startGamblingSession(gameInfo: GameInfo, isFreePlay: boolean): Promise<GameStepsExecutionResultEnum>;
    readonly analytics: IGamblingSessionAnalytics;
}

